import { useTranslation } from '@ecomm/i18n'
import { useCallback } from 'react'
import { useTrackingDropdownMenu } from '../../../hooks/useTrackingDropdownMenu'
import { DesktopDropdownMenu } from '../DesktopDropdownMenu'
import type { HeaderRedesignSchema } from '../schema'
import { AvailableTime } from './AvailableTime'
import { CallSpecialistImage } from './CallSpecialistImage'

type CallSpecialistDropdownMenuProps = Pick<HeaderRedesignSchema, 'images'> & {
  readonly onToggleDropdown: (close?: boolean) => void
  readonly showDropdown: boolean
  // (sideNav === true) => This dropdown menu is being displayed in the side nav and not in desktop mode
  readonly sideNav: boolean
}

export function CallSpecialistDropdownMenu({
  images,
  showDropdown,
  sideNav,
  onToggleDropdown
}: CallSpecialistDropdownMenuProps) {
  const { t } = useTranslation('header')
  const PHONE_NUMBER_SPECIALIST = t(
    'call-specialist-dropdown-menu.phone-specialist'
  )
  const trackClick = useTrackingDropdownMenu()

  const onClick = useCallback(() => {
    onToggleDropdown(true)
    trackClick(PHONE_NUMBER_SPECIALIST)
  }, [PHONE_NUMBER_SPECIALIST, onToggleDropdown, trackClick])

  return (
    <DesktopDropdownMenu
      title="CallSpecialistDropdownMenu"
      showDropdown={showDropdown}
      sideNav={sideNav}
      baseClassNames="top-[60px] rounded-lg py-6 px-5 text-neutral-black bg-neutral-black z-10 w-full shadow-lg border border-solid border-slate-100 before:absolute before:-top-1 before:left-1/2 before:z-[0] before:block before:h-6 before:w-6 before:-translate-x-1/2 before:rotate-45 before:transform before:bg-white lg:absolute lg:left-1/2 lg:w-max lg:-translate-x-1/2 lg:bg-white lg:before:content-['']"
      dataTestId="callspecialist-dropdown-menu"
    >
      <div className="flex">
        <div className="mr-4">
          <div className="text-sm font-normal opacity-90">
            {t('call-specialist-dropdown-menu.call-sales-specialist')}
          </div>
          <a
            className="font-bold text-xl hover:underline no-underline text-neutral-black"
            href={`tel:${String(PHONE_NUMBER_SPECIALIST)}`}
            onClick={onClick}
            rel="noreferrer"
            tabIndex={showDropdown ? 0 : -1}
          >
            {PHONE_NUMBER_SPECIALIST}
          </a>
        </div>
        <div>
          <CallSpecialistImage images={images} />
        </div>
      </div>
      <AvailableTime />
    </DesktopDropdownMenu>
  )
}
